<template>
  <v-app style="">
    <go-top></go-top>

    <div
      style="margin-top: 100px;height: 25px;background-image: linear-gradient(white, #faf8ed);"
    ></div>
    <div style="background-color: #faf8ed;">
      <v-layout wrap class="container">
        <v-flex xs12 md6 sm12>
          <h1 class="discover">
            Discover the<br />Best <span class="lovely">Lovely</span><br />Places
          </h1>
          <p class="plan">
            Plan and book your perfect trip with expert advice, travel<br />
            tips, destination information and inspiration from us.
          </p>

          <v-btn
            style="border-radius: 20px !important;background-color: #f66f4d;margin-left: -5px;font-size: 20px;color: white;"
          >
            Explore Your Destinations
          </v-btn>
        </v-flex>
        <v-flex xs12 md6 sm12>
          <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
            <v-card
              elevation="16"
              class="banner"
              v-for="owl in items"
              :key="owl.src"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.45)),url(${
                  owl.src
                })`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }"
            >
              <h1 class="bannerTitle">{{ owl.title }}</h1>
            </v-card>
          </carousel>
        </v-flex>
      </v-layout>
    </div>

    <div style="background-color: white;padding-top: 50px;">
      <div class="container" v-if="categories.length>0">
        <h1 class="theme">Tour Themes</h1>
        <p class="themeP">
          Here are lots of interesting destinations to visit,<br />
          but don’t be confused—they’re already grouped<br />
          by category.
        </p>
        <carousel
          style="text-align: center;"
          :autoplay="true"
          :items="6"
          :nav="false"
          :dots="false"
        >
          <div v-for="owl in categories">
            <img class="catImg" :src="owl.src" />
            <h4 class="catTitle">{{ owl.title }}</h4>
          </div>
        </carousel>
      </div>
    </div>

    <div style="padding-top: 50px;background-color: #FAF8ED;">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-sm-12 col-md-6">
            <img style="width: 100%;" src="../../assets/mjm.jpeg" />
          </div>
          <div class="col-lg-6 col-sm-12 col-md-6">
            <p class="txt_my" style="color: #F78163;font-weight: bold;">
              O u r &nbsp;&nbsp;&nbsp;E x p e r i e n c e
            </p>
            <h1 class="stories">Our Stories Have <br />Adventures</h1>
            <p class="plan1">
              We are experienced in bringing adventures to stay their journey, with all outdoor
              destinations in the world as our specialties. Start your adventure now! Nature has
              already called you!
            </p>

            <div class="row" style="padding-top: 40px;">
              <div class="col-lg-4 col-sm-12 col-md-6">
                <v-card style="text-align: center;">
                  <h1 class="stories1">12K+</h1>
                  <p class="journey">Success Journey</p>
                </v-card>
              </div>
              
              <div class="col-lg-4 col-sm-12 col-md-6">
                <v-card style="text-align: center;">
                  <h1 class="stories1">20+</h1>
                  <p class="journey">Years of experience</p>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: white;padding-top: 50px;">
      <div class="container" v-if="domesticList.length>0">
        <h1 class="theme">Domestic Tour Destinations</h1>
        <p class="themeP">
          Here are lots of interesting destinations to visit,<br />
          but don’t be confused—they’re already grouped<br />
          by category.
        </p>
        <carousel :autoplay="true" :items="4" :nav="false" :dots="false">
          <div v-for="owl in domesticList">
            <v-card @click="view(owl)" style="margin: 10px;background-color: #FAF8ED;">
              <img class="domImg" :src="owl.src" />
              <h4 class="domTitle">{{ owl.name.substring(0, 20) }}... ({{ owl.day }} Days)</h4>
              <p
                style="padding-left: 5px;margin-top: -10px;color: grey;font-size: 12px;"
                class="txt_my"
              >
                {{ owl.subTitle }}
              </p>
              <div style="display: flex;align-items: center;">
                <h6 style="color: #f66f4d;" class="txt_my">
                  {{ owl.actualRate }}
                </h6>
              </div>
              <div style="text-align: center;">
                <v-btn block small style="border-radius: 20px !important;color: grey;" flat outline>
                  View Details
                </v-btn>
              </div>
            </v-card>
          </div>
        </carousel>
      </div>
    </div>

    <div style="background-color: #FAF8ED;padding-top: 70px;">
      <div class="container">
        <h1 class="theme" style="text-align: center;">International Tour Destinations</h1>
        <p class="themeP" style="text-align: center;">
        </p>

        <div class="row" style="padding-top: 20px;" v-if="internationalList.length>0">
          <div class="col-lg-3 col-md-3 col-sm-12">
            <v-card
              @click="view(internationalList[0])"
              elevation="2"
              style="height: 200px;background-size: cover;color: white;position: relative;width: 100%;"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                  internationalList[0].src
                })`
              }"
            >
              <p style="font-size: 20px;font-weight: bold;">{{ internationalList[0].title }}</p>
              <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[0].time }}</p>
              <v-btn
                small
                style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                dark
                flat
                outline
                @click="view(internationalList[0])"
                >Book Now</v-btn
              >
            </v-card>
            <v-card
            @click="view(internationalList[1])"
              elevation="2"
              style="height: 200px;background-size: cover;color: white;position: relative;margin-top: 15px;width: 100%;"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                  internationalList[1].src
                })`
              }"
            >
              <p style="font-size: 20px;font-weight: bold;">{{ internationalList[1].title }}</p>
              <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[1].time }}</p>
              <v-btn
                small
                style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                dark
                flat
                outline
                @click="view(internationalList[1])"
                >Book Now</v-btn
              >
            </v-card>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <v-card
            @click="view(internationalList[3])"
              elevation="2"
              style="height: 415px;background-size: cover;color: white;position: relative;width: 100%;"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                  internationalList[3].src
                })`
              }"
            >
              <p style="font-size: 20px;font-weight: bold;">{{ internationalList[3].title }}</p>
              <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[3].time }}</p>
              <v-btn
                small
                style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                dark
                flat
                outline
                @click="view(internationalList[3])"
                >Book Now</v-btn
              >
            </v-card>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12">
            <v-card
            @click="view(internationalList[4])"
              elevation="2"
              style="height: 200px;background-size: cover;color: white;position: relative;width: 100%;"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                  internationalList[4].src
                })`
              }"
            >
              <p style="font-size: 20px;font-weight: bold;">{{ internationalList[4].title }}</p>
              <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[4].time }}</p>
              <v-btn
                small
                style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                dark
                flat
                outline
                @click="view(internationalList[4])"
                >Book Now</v-btn
              >
            </v-card>
            <div style="display: flex;align-items: center;margin-top: 15px;">
              <v-card
              @click="view(internationalList[2])"
                elevation="2"
                style="height: 200px;background-size: cover;color: white;position: relative;margin-right: 7px;width: 100%;"
                :style="{
                  backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                    internationalList[2].src
                  })`
                }"
              >
                <p style="font-size: 20px;font-weight: bold;">{{ internationalList[2].title }}</p>
                <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[2].time }}</p>
                <v-btn
                  small
                  style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                  dark
                  flat
                  outline
                  @click="view(internationalList[2])"
                  >Book Now</v-btn
                >
              </v-card>
              <v-card
              @click="view(internationalList[5])"
                elevation="2"
                style="height: 200px;background-size: cover;color: white;position: relative;margin-left: 7px;width: 100%;"
                :style="{
                  backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                    internationalList[5].src
                  })`
                }"
              >
                <p style="font-size: 20px;font-weight: bold;">{{ internationalList[5].title }}</p>
                <p style="font-size: 12px;margin-top: -15px;">{{ internationalList[5].time }}</p>
                <v-btn
                  small
                  style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                  dark
                  flat
                  outline
                  @click="view(internationalList[6])"
                  >Book Now</v-btn
                >
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: white;padding-top: 50px;">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-sm-12 col-md-6">
            <img style="width: 100%;" src="../../assets/india.png" />
          </div>
          <div class="col-lg-6 col-sm-12 col-md-6">
            <h1 class="stories">A Customer Said <br />About Us:</h1>

            <v-card style="margin-top: 50px;">
              <v-container>
                <carousel :autoplay="true" :items="1" :nav="false" :dots="true">
                  <div v-for="owl in testimonialList" :key="owl.id">
                    <p style="text-align: justify;" class="txt_my">{{ owl.comment }}</p>
                    <v-rating
                      v-model="owl.star"
                      color="#f7da00"
                      half-increments
                      style="align-items: left;text-align: left;"
                    ></v-rating>
                    <h6 style="font-weight: bold;font-size: 16px;padding-top: 15px;" class="txt_my">
                      {{ owl.name }}
                    </h6>
                    <p style="color: #848383;" class="txt_my">{{ owl.address }}</p>
                  </div>
                </carousel>
              </v-container>
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #FAF8ED;padding-top: 70px;">
      <v-container>
        <v-container>
          <v-card
            style="background-image: url('https://sasitechnologies.in/intersect.png');background-color: #ffd482;background-size: cover;padding-bottom: 50px;"
          >
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-12"></div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <h2 style="text-align: center;padding-top: 45px;font-weight: bold;" class="txt_my">
                  Contact us for more information 
                </h2>
                <p
                  style="text-align: center;padding-top: 10px;font-weight: 300;color: #848383;"
                  class="txt_my"
                >
                  Reciev latest news, update, and many other things<br />
                  every week.
                </p>
                
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12"></div>
            </div>

            <div style="display: flex;">
              <b-input-group prepend="👤" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input v-model="form.name" id="inline-form-input-username" placeholder="Enter Your Name"></b-form-input>
              </b-input-group>
              <b-input-group prepend="✉" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input v-model="form.email" id="inline-form-input-username" placeholder="Enter Your Email address"></b-form-input>
              </b-input-group>
              <b-input-group prepend="☎" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input v-model="form.mobileNo" id="inline-form-input-username" placeholder="Enter Your Mobile number"></b-form-input>
              </b-input-group>
                <v-btn @click="onSubmit()" :loading="btnSave" style="border-radius: 20px !important;background-color: #f66f4d;color: white;margin-top: -3px;" color="#f66f4d" flat><v-icon :size="20">send</v-icon>
              </v-btn>    
                </div>
          </v-card>
        </v-container>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from "vue-owl-carousel";
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from "@inotom/vue-go-top";

export default {
  components: {
    GoTop,
    carousel
  },
  data() {
    return {
      items: [
        {
          src:
            "https://majumderspecial.in/kashmir.jpeg",
          title: "KASHMIR"
        },
        {
          src: "https://majumderspecial.in/rajasthan.jpg",
          title: "RAJASTHAN"
        },
        {
          src: "https://majumderspecial.in/kerala.cms",
          title: "KERALA"
        },
        {
          src:
            "https://majumderspecial.in/tajmahal.avif",
          title: "TAJ MAHAL"
        }
      ],
      valid: true,
      btnSave: false,
      form: {
        tourPackage: null,
        destination: null
      },

      categories: [],

      destinations: [
        {
          name: "Kashmir",
          id: 1
        },
        {
          name: "Rajasthan",
          id: 1
        },
        {
          name: "Himachal Pradesh",
          id: 1
        },
        {
          name: "Delhi",
          id: 1
        },
        {
          name: "Mumbai",
          id: 1
        }
      ],
      selectedDestination: null,

      owlCount: [],

      owlCount1: [],

      owlCount3: [],

      owlCount2: [],

      mainOwl: [
        {
          src: "https://bishnutoursandtravels.com/banner-1.png"
          // "name": "Start Your Travel Journey"
        },
        {
          src: "https://bishnutoursandtravels.com/banner-2.png"
          // "name": "Find Great Deals & Travel Around The World"
        },
        {
          src: "https://bishnutoursandtravels.com/banner-3.png"
          // "name": "Explore The World"
        }

        //   {
        //     "src": "https://api.bishnutoursandtravels.com/wwwroot/HomeBannerPic/banner-4.png",
        //  }
      ],
      tourPackage: [],
      tourPackage1: [],
      blogCount: [],

      domesticList: [],

      internationalList: [],

      testimonialList: [
        {
          id: 1,
          comment:
            "Very good experience. Majumder special always try to satisfy their tourist guys. Fooding arrangement keep healthy first to Kept fit tourist guys for long travels. Any person may go their trip with Majumder special.",
          star: 5,
          name: "Dipnarayan Mondal",
          address: "2 months ago"
        },
        {
          id: 2,
          comment:
            "Very very good travel agent, hotels are good, quality food & warm hospitality- their key, highly recommended to go with Majumder Special",
          star: 5,
          name: "Shibu Pal",
          address: "2 months ago"
        },
        {
          id: 3,
          comment:
            "Excellent Tour Company. In 2015 we go for kumayan trip with them with 10 months old baby. They Provide very good hotel, food in a very affordable price. Also help us every time when we face any kind issue. Keep up the great service...",
          star: 5,
          name: "Avishek Dutta",
          address: "7 years ago"
        },
        {
          id: 4,
          comment:
            "Best travel agency ever. The provide good hotels clean rooms as well as homely food at a reasonable price. Comparing to other travel agency's food menu thair food is much better and testy also. They don't have limitation for food. If you ask for extra food they never says no. Every evening they provide snacks like chowmin, sandwiches, pakora etc. When the cooking is not possible for the evening time then the provide package food like biskits, cakes, chanachur, chips for snacks. Vachels are also very comfortable. If needed they also provide ac Vachels. I am a very happy traveler with majumder special. Every staff of majumder special is very well behaved. I recommend all my friends to travel with them. It was a great experience.",
          star: 5,
          name: "madhurima ghatak",
          address: "5 years ago"
        }
      ],

      form: {
        name: '',
        mobileNo: '',
        email: ''
      }
    };
  },

  mounted() {

    this.axios
      .get(config.API + "TourThemes", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
         console.log(res.data);
         for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          this.categories.push({
            id: element.id,
            title: element.name,
            src: config.API + "ThemeUpload/" + element.themeCode
          })

          console.log(this.categories);
         }
      });

    /* this.axios
      .get(config.API + "Home", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.owlCount = res.data;
      });

    this.axios
      .get(config.API + "Home1", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.owlCount1 = res.data;
      });

    this.axios
      .get(config.API + "Home2", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.owlCount3 = res.data;
      });

    this.axios
      .get(config.API + "Home3", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.owlCount2 = res.data;
      });

    this.axios
      .get(config.API + "Home4", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.blogCount = res.data;
      }); */

    this.axios
      .get(config.API + "TourPackages1", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        let _list = res.data;
        let i = _list.length;
        let j = 0;
        let itemAdded = [];
        for (let index = 0; index < _list.length; index++) {
          const element = _list[index];
          itemAdded.push({
            id: element.id,
            name: element.name,
            day: element.day,
            actualRate: element.actualRate,
            destinationCode: element.destinationCode,
            src: config.API + "DestinationUpload/" + element.destinationCode
          })
          j++;
          if(i==j) {
            this.domesticList=itemAdded;
            console.log("Domestic", this.domesticList);
          }
        }
      });

    this.axios
      .get(config.API + "TourPackages2", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        console.log("Inter", res.data);
        let _list = res.data;
        let i = _list.length;
        let j = 0;
        let itemAdded = [];
        for (let index = 0; index < _list.length; index++) {
          const element = _list[index];
          itemAdded.push({
            id: element.id,
            name: element.name,
            title: element.name,
            day: element.day,
            night: element.night,
            actualRate: element.actualRate,
            price: element.actualRate,
            rate: element.rate,
            destinationCode: element.destinationCode,
            time: element.day + " Days, " + element.night + " Nights",
            src: config.API + "DestinationUpload/" + element.destinationCode
          })
          j++;
          if(i==j) {
            this.internationalList=itemAdded;
            console.log("internationalList", this.internationalList);
          }
        }
      });
  },

  methods: {
    thmpkg(owl) {
      this.$router.push("/themePackage/" + owl.id);
    },
    despkg(owl) {
      this.$router.push("/destinationPackage/1"); // + owl.id
    },
    despkg1(owl) {
      this.$router.push("/destinationPackageInt/" + owl.id);
    },
    take(owl) {
      this.$router.push("/destinationPackage/" + owl.id);
    },
    read(owl) {
      this.$router.push("/blogDetails/" + owl.id);
    },
    view(des) {
      sessionStorage.setItem("Detail", JSON.stringify(des));
      this.$router.push("/packageDetails/" + des.id); // + des.id
    },
    packages() {
      this.$router.push("/packages");
    },

    onSubmit() {
      if (this.form.name!=''&&this.form.mobileNo!=''&&this.form.email!='') {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Contacts`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNo: this.form.mobileNo,
              comment: this.form.comment,
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Thank you for your time. Our team will contact you soon.");
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },
  }
};
</script>

<style scoped>
@import "../../HomeCss/home.css";

@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>

<style scoped>
.banner {
  margin-top: 0px;
  background-size: cover;
  width: 100%;
  height: 350px;
}

.bannerTitle {
  margin: 0;
  text-align: center;
  color: white;
  font-size: 50px;
  font-family: "Alice", serif !important;
}

.discover {
  font-family: "Alice", serif !important;
  font-size: 64px;
}
.stories {
  font-family: "Alice", serif !important;
  font-size: 54px;
}
.stories1 {
  font-family: "Alice", serif !important;
  font-size: 45px;
  color: #f66f4d;
}
.txt_my {
  font-family: "Alice", serif !important;
}
.lovely {
  color: #f66f4d;
  font-family: "Alice", serif !important;
}
.journey {
  font-family: "Alice", serif !important;
  font-size: 15px;
  color: grey;
}

.theme {
  font-family: "Alice", serif !important;
  font-weight: bold;
}

.themeP {
  font-family: "Alice", serif !important;
  padding-top: 15px;
}

.plan {
  padding-top: 10px;
  font-size: 18px;
  font-family: "Alice", serif !important;
  text-align: justify;
}
.plan1 {
  padding-top: 10px;
  font-size: 16px;
  font-family: "Alice", serif !important;
  text-align: justify;
}

.catImg {
  padding: 30px;
  display: block;
  margin: auto;
}

.domImg {
  padding: 5px;
  display: block;
  margin: auto;
  border-radius: 10px;
  height: 180px;
  width: 100%;
}

.catTitle {
  font-family: "Alice", serif !important;
  text-align: center !important;
  font-size: 18px;
  margin-top: -15px;
}

.domTitle {
  font-family: "Alice", serif !important;
  text-align: left !important;
  font-size: 16px;
  font-weight: 500;
  padding: 5px;
}

.tourtheme2 {
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.package-details {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.review {
  display: flex;
}
.rating-icon {
  display: flex;
  justify-content: space-around;
}
.tour-packages-img {
  max-width: 400px !important;

  max-height: 400px !important;
}
.tour-packages-img img {
  max-width: 400px !important;

  max-height: 400px !important;
}
.price {
  display: flex;
  justify-content: space-between;
}
.price-box p {
  margin-bottom: 5px;
  font-weight: 500;
}
.rating-icon img {
  height: 18px;
  margin-right: 3px;
}
.hot-tours-img {
  overflow: hidden;
  height: 100px;
  width: 100px;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 10px;
}

.tour-packages-title p {
  margin-bottom: 0px;
}
.hot-tours-img img {
  height: 100px;
  width: 100px;
  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.hot-tours-card:hover .hot-tours-img img {
  transform: scale(1.15);
}

.hot-tours-card:hover .tourtheme2 {
  background-size: 120%;
  transition-duration: 0.7s;
}
.hot-tours-card:hover .hot-tours .title h4 {
  color: #024c94;
}
.hvr2:hover {
  cursor: pointer;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.hot-tours {
  display: flex;
  align-items: center;
}
.next-trip-card {
  background-color: transparent !important;
}
.why-us-img img {
  max-width: 100%;
  max-height: 100%;
}
.why-us {
  margin-top: 40px;
}
.why-us p,
.why-us-box p {
  color: #697488;
}
.why-us-box h4 {
  margin-bottom: 0;
}
.why-us-box {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 15px;
}
.why-us-box img {
  padding-right: 10px;
  height: 50px;
}
.next-trip-img {
  overflow: hidden;
  max-height: 350px;
  max-width: 400px;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 10px;
}
.next-trip-img img {
  max-height: 350px;
  max-width: 400px;
  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.next-trip-card:hover .next-trip-img img {
  transform: scale(1.15);
}
.next-trip-title p {
  color: #a5a5a5;
}
.hot-tours .title {
  display: block;
}
.hot-tours .title p {
  font-size: 14px !important;
  color: #a5a5a5;
}
.box {
  text-align: center;
}
.box h1 {
  color: #024c94;
}
.box p {
  color: #a5a5a5;
}

.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: "Open Sans", sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: "Metal Mania", cursive;
  font-size: 60px;
  padding-top: 230px;
  color: white;
  text-align: center;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border: 3px solid;
  border-color: black;
}
.section-heading {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.v-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
  .banner {
    height: 150px;
  }
  .section-heading {
    flex-direction: column;
  }
}
@media screen and (min-width: 768px) {
  .man {
    display: none;
  }
}
</style>
